import { useEffect, useState } from "react";

const PHRASES = [
  "Plan je elektrische roadtrip.",
  "Laadstops. Zonder stress.",
  "Geen range anxiety. Puur avontuur.",
  "Rij. Laad. Herbeleef.",
];

export const Typewriter = ({ phrases = PHRASES, accentClass = "text-[#74C69D]" }) => {
  const [text, setText] = useState("");
  const [idx, setIdx] = useState(0);
  const [deleting, setDeleting] = useState(false);
  const reduced = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;

  useEffect(() => {
    if (reduced) { setText(phrases[0]); return; }
    const phrase = phrases[idx % phrases.length];
    let t;
    if (!deleting && text === phrase) {
      t = setTimeout(() => setDeleting(true), 2200);
    } else if (deleting && text === "") {
      setDeleting(false);
      setIdx((i) => i + 1);
    } else {
      t = setTimeout(() => setText(phrase.slice(0, text.length + (deleting ? -1 : 1))), deleting ? 26 : 52);
    }
    return () => clearTimeout(t);
  }, [text, deleting, idx, reduced, phrases]);

  return (
    <h1 data-testid="hero-typewriter"
      className="font-heading font-light text-4xl sm:text-5xl lg:text-6xl text-white tracking-tighter leading-tight min-h-[1.3em]">
      {text}
      <span className={`typewriter-cursor ${accentClass}`} aria-hidden="true">|</span>
    </h1>
  );
};
